// extracted by mini-css-extract-plugin
export default {"base":"vp_nKjVd","buttonWrapper":"vp_KXRw4","button":"vp_LRLg0"};